import { jsx as _jsx } from "react/jsx-runtime";
import { StepIndicator } from "components/Common/StepIndicator";
import { FormattedMessage } from "react-intl";
const SIGNUP_LABELS = [
    _jsx(FormattedMessage, { id: "stepIndicator.step1", description: "signup step1", defaultMessage: "Registration method" }, "step1"),
    _jsx(FormattedMessage, { id: "stepIndicator.step2", description: "signup step2", defaultMessage: "Confirm/Accept" }, "step2"),
    _jsx(FormattedMessage, { id: "common.verifyEmailAddress", description: "signup step3", defaultMessage: "Verify email address" }, "step3"),
    _jsx(FormattedMessage, { id: "stepIndicator.step4", description: "signup step4", defaultMessage: "Sign-in method" }, "step4"),
    _jsx(FormattedMessage, { id: "common.completed", description: "signup step5", defaultMessage: "Completed" }, "step5"),
];
export function SignupStepIndicator({ currentStep }) {
    return _jsx(StepIndicator, { currentStep: currentStep, totalSteps: 5, labels: SIGNUP_LABELS });
}
